import i18next from 'i18next'
import type { ReactNode } from 'react'
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary'
import { ErrorBox } from '@/components/commons/error-box'
import { ButtonBrandLegacy } from '@/components/ui/button-brand-legacy'
import { AlertCircleIcon } from '@/components/ui/icons'

const ErrorFallback = () => (
	<ErrorBox
		cta={
			<ButtonBrandLegacy onClick={() => window.location.reload()}>
				{i18next.t('common:reload_the_page')}
			</ButtonBrandLegacy>
		}
		icon={<AlertCircleIcon />}
		title={i18next.t('errors:default')}
	/>
)

export const ErrorBoundary = ({ children }: { children: ReactNode }) => (
	<ReactErrorBoundary FallbackComponent={ErrorFallback}>
		{children}
	</ReactErrorBoundary>
)
